import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { ItemAlertsSearchSchema } from './-zod-schema';

export const Route = createFileRoute(
  '/_staff/equipment/items/$id/_detail/alerts/',
)({
  validateSearch: zodValidator(ItemAlertsSearchSchema),
});
